export enum MassImportStatus{
    UPLOADED = 'UPLOADED',
    PROCESSING = 'PROCESSING',
    COMPLETE = 'COMPLETE',
    FAILED = 'FAILED',
    DELETED = 'DELETED',
}